module.exports = __webpack_public_path__ + "media/tycho2t3_80_py.c7fdec95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_py.jpg
// module id = 1091
// module chunks = 0